import { createClient } from '@supabase/supabase-js';

// Konfiguration für echte Authentifizierung
const SUPABASE_URL = 'https://zagyktuogfzvyqrefybn.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InphZ3lrdHVvZ2Z6dnlxcmVmeWJuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQxNjcyMDEsImV4cCI6MjA3OTc0MzIwMX0.J5OPR1Yoc4W8lb7AbQjd1zpEfzS2Rmcjvx-7mmDCn3k';

const isConfigured = SUPABASE_URL && SUPABASE_ANON_KEY;

export const supabase = isConfigured ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
}) : null;

export const isSupabaseConfigured = () => !!supabase;